import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_EDUCATION_DATA, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    getRssFeedData:
        (userType: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (state.educationState && state.educationState.educationData != null && state.educationState.educationData.length < 1) {
                dispatch({ type: SHOW_LOADER, isLoading: true });
                services
                    .getRSSFeed("1", userType + "-resources", "blogs")
                    .then((data) => {
                        dispatch({ type: RECEIVE_EDUCATION_DATA, educationData: data });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        const temp = error;
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
